export default "__VITE_ASSET__BbUzQiMH__"